<template>
    <div class="editor">
        <h2>Gathering structure{{ name ? ' - ' + name : ''}}</h2>
        <div class="button-row">
            <button id="download" @click="loadData()">Load data</button>
            <button id="download" @click="reset()">Reset</button>
        </div>
        <div class="data">
            <input v-model="name" class="name" placeholder="Name"/>
            <h4>Paper types</h4>
            <div class="paper-type" v-for="(type, i) in paperTypes" :key="type.id">
                <input v-model="type.name" placeholder="Name"/>
                <button @click="paperTypes.splice(i,1)" class="del">delete paper type</button>
            </div>
            <button class="add" @click="addPaperType()">add paper type</button>
            <h4>Sheets</h4>
            <div class="sheet" v-for="(sheet,i) in sheets" :key="sheet.id">
                <input v-model="sheet.name" placeholder="Folio Number"/>
                <input class="desc" v-model="sheet.description" placeholder="Additional information"/>
                <select v-model="sheet.paperType">
                    <option value="" disabled selected>Select paper type</option>
                    <option v-for="o in paperTypes" :key="o.id" :value="o.id">{{o.name}}</option>
                </select>
                <div class="connections">
                    <div class="connection" v-for="(connection,j) in sheet.connections" :key="j">
                        <select v-model="connection.type">
                            <option v-for="o in connectionTypes" :key="o.id" :value="o.id">{{o.name}}</option>
                        </select>
                        <select v-model="connection.to">
                            <option v-for="s in getSheets(sheet)" :key="s.id" :value="s.id">{{s.name}}</option>
                        </select>
                        <button @click="sheet.connections.splice(j,1)">delete connection</button>
                    </div>
                    <button @click="addConnection(sheet)">add connection</button>
                </div>
                <button @click="sheets.splice(i,1)" class="del">delete sheet</button>
            </div>
            <button class="add" @click="addSheet()">add sheet</button>
        </div>
        <h2>Output:</h2>
        <div id="canvas"></div>
        <div class="button-row">
            <button id="download" @click="downloadSVG()">Download Image</button>
            <button id="download" @click="downloadJSON()">Download data</button>
        </div>
    </div>
</template>

<script>
import { SVG } from '@svgdotjs/svg.js'

export default {
    name: 'LagenschemaEditor',
    data() {
        return {
            name: '',
            svg: false,
            sheets: [
                {
                    id: 1,
                    name: '1r',
                    description: '',
                    connections: []
                }
            ],
            connectionTypes: [
                { id: 1, name: 'connected to' },
                { id: 2, name: 'glued to' },
                { id: 3, name: 'broken connected to' }
            ],
            paperTypes: []
        }
    },
    mounted() {
        if(localStorage.getItem("data")) {
            let data = JSON.parse(localStorage.getItem("data"))
            if((data.sheets.length > 1 || data.paperTypes.length > 0) && confirm("Do you want to load the previous configuration?")) {
                this.name = data.name
                this.paperTypes = data.paperTypes
                this.sheets = data.sheets
            } else localStorage.removeItem("data")
        }
        this.svg = SVG().addTo('#canvas').size(300, 300)
        this.render()
    },
    methods: {
        addConnection(sheet) {
            sheet.connections.push({
                to: this.getSheets(sheet).length > 0 ? this.getSheets(sheet)[0] : false,
                type: 1
            })
        },
        addSheet(name) {
            this.sheets.push({
                id: this.sheets.length > 0 ? this.sheets[this.sheets.length-1].id+1 : 1,
                name: name ? name : '',
                description: '',
                connections: []
            })
        },
        getSheets(sheet) {
            return this.sheets.filter(s => {
                return s != sheet
            })
        },
        addPaperType() {
            this.paperTypes.push({
                id: this.paperTypes.length > 0 ? this.paperTypes[this.paperTypes.length-1].id+1 : 1,
                name: ''
            })
        },
        render() {
            localStorage.setItem("data", JSON.stringify({
                name: this.name,
                sheets: this.sheets,
                paperTypes: this.paperTypes
            }))
            this.svg.clear()
            this.svg.height(this.sheets.length*40)
            let connections = []
            this.sheets.forEach(s => {
                s.connections.forEach(c => {
                    if(c.to && c.type && this.sheets.find(s2 => s2.id == c.to)) {
                        connections.push({
                            from: s.id,
                            to: c.to,
                            type: c.type,
                            layer: 1,
                            distance: Math.abs(this.sheets.indexOf(s)-this.sheets.indexOf(this.sheets.find(s2 => s2.id == c.to)))
                        })
                    }
                })
            })
            let ls = []
            connections.forEach(c => {
                if(!ls.includes(c.distance)) ls.push(c.distance)
            })
            ls.sort((a,b) => {
                return a > b
            })
            connections.sort((a,b) => {
                return a.distance > b.distance
            })
            /*let getLayers = function(c, sheets) {
                if(c.distance == 1) return 1
                let envelops = []
                let from = sheets.indexOf(sheets.find(s => s.id == c.from))
                let to = sheets.indexOf(sheets.find(s => s.id == c.to))
                for(let i = from+1; i < to; i++) {
                    let conns = connections.filter(conn => {
                        let f = sheets.indexOf(sheets.find(s => s.id == conn.from))
                        let t = sheets.indexOf(sheets.find(s => s.id == conn.to))
                        return from <= f && to > t
                    })
                    conns.forEach(conn => {
                        envelops.push(getLayers(conn, sheets))
                    })
                }
                if(envelops.length < 1) envelops = [0]
                return Math.max(...envelops)+1
            }*/
            let isEnveloped = function(sheet, sheets) {
                let layers = 0
                connections.forEach(c => {
                    if(c.from < sheets.indexOf(sheet)+1 && c.to > sheets.indexOf(sheet)+1) layers++
                })
                return layers
            }
            let layers = {}
            let maxLayer = 1
            connections.forEach(c => {
                //let layer = getLayers(c, this.sheets)
                let layer = ls.length-ls.indexOf(c.distance)
                if(!layers[layer]) layers[layer] = []
                layers[layer].push(c)
                if(layer > maxLayer) maxLayer = layer
            })
            let width = 0
            this.sheets.forEach((s,i) => {
                let text = this.svg.text(s.name)
                text.stroke({ width: 0 })
                text.move((maxLayer)*20+20, (i+1)*40-30).font({ family: 'Helvetica', size: 20, anchor: 'left' })
                let desc = this.svg.text(s.description)
                desc.stroke({ width: 0 })
                desc.move((maxLayer+1)*20+50, (i+1)*40-30).font({ family: 'Helvetica', size: 20, anchor: 'left' })
                if(desc.bbox().width > width) width = desc.bbox().width
                let conns = connections.filter(c => { return c.from == i+1 || c.to == i+1 })
                if(conns.length == 0) {
                    let l = isEnveloped(s, this.sheets)
                    this.svg.line(l*20+(l == 0 ? 5 : 0), i*40+20, (maxLayer*20)+10, i*40+20)
                    this.svg.stroke({ color: 'black', width: 2 })
                }
            })
            let paperTypeGroups = []
            this.paperTypes.forEach(pt => {
                let groups = []
                let shts = this.sheets.filter(s => s.paperType == pt.id)
                if(shts) {
                    shts.forEach(s => {
                        if(groups.length > 0 && groups[groups.length-1].to == this.sheets.indexOf(s)-1) {
                            groups[groups.length-1].to = this.sheets.indexOf(s)
                        } else {
                            groups.push({
                                from: this.sheets.indexOf(s),
                                to: this.sheets.indexOf(s)
                            })
                        }
                    })
                }
                paperTypeGroups.push({
                    paperType: pt,
                    groups
                })
            })
            this.svg.width(width+(maxLayer+1)*40+50)
            Object.keys(layers).forEach(l => {
                let conns = layers[l]
                conns.forEach(conn => {
                    let from = this.sheets.indexOf(this.sheets.find(s => s.id == conn.from))
                    let to = this.sheets.indexOf(this.sheets.find(s => s.id == conn.to))
                    if([1,3].includes(conn.type)) {
                        this.svg.stroke({ color: 'black', width: 2 })
                        this.svg.line(((maxLayer-l)*20)+5, from*40+19, ((maxLayer-l)*20)+5, to*40+21)
                        this.svg.stroke({ color: 'black', width: 2 })
                        this.svg.line(((maxLayer-l)*20)+5, from*40+20, maxLayer*20+10, from*40+20)
                        this.svg.stroke({ color: 'black', width: 2 })
                        this.svg.line(((maxLayer-l)*20)+5, to*40+20, maxLayer*20+10, to*40+20)
                        this.svg.stroke({ color: 'black', width: 2 })
                        if(conn.type == 3) {
                            this.svg.line((maxLayer-l)*20+1, (from+(to-from)/2)*40+15, (maxLayer-l)*20+9, (from+(to-from)/2)*40+20)
                            this.svg.stroke({ color: 'black', width: 2 })
                            this.svg.line((maxLayer-l)*20+1, (from+(to-from)/2)*40+20, (maxLayer-l)*20+9, (from+(to-from)/2)*40+25)
                            this.svg.stroke({ color: 'black', width: 2 })
                        }
                    } else if(conn.type == 2) {
                        this.svg.path('M '+(((maxLayer-l)*20)+30)+' '+(from*40+20)+
                                        ' C '+((maxLayer-l)*20)+' '+(from*40+20)+
                                        ' '+((maxLayer-l)*20)+' '+(to*40+20)+
                                        ' '+(((maxLayer-l)*20)+30)+' '+(to*40+20)).stroke({ color: 'black', width: 2 }).fill('transparent')
                        this.svg.path('M '+(((maxLayer-l+1)*20+10))+' '+(from*40+20)+' L '+(maxLayer*20+10)+' '+(from*40+20))
                        this.svg.stroke({ color: 'black', width: 2 })
                        this.svg.path('M '+(((maxLayer-l+1)*20+10))+' '+(to*40+20)+' L '+(maxLayer*20+10)+' '+(to*40+20))
                        this.svg.stroke({ color: 'black', width: 2 })
                    }
                })
            })
            let left = this.svg.bbox().w+20
            paperTypeGroups.forEach(ptg => {
                ptg.groups.forEach(g => {
                    if(g.to - g.from == 0) {
                        let text = this.svg.text(ptg.paperType.name)
                        text.stroke({ width: 0 })
                        text.move(left, (g.to+1)*40-30).font({ family: 'Helvetica', size: 20, anchor: 'left' })
                    } else {
                        let text = this.svg.text(ptg.paperType.name)
                        text.stroke({ width: 0 })
                        text.move(left, (g.from+((g.to-g.from)/2)+1)*40-30).font({ family: 'Helvetica', size: 20, anchor: 'left' })
                        let width = text.bbox().w

                        this.svg.line(left, (g.from+1)*40-20, left, (g.from+1)*40-30).stroke({ color: 'black', width: 2 })
                        this.svg.line(left, (g.from+1)*40-30, left+width, (g.from+1)*40-30).stroke({ color: 'black', width: 2 })
                        this.svg.line(left+width, (g.from+1)*40-30, left+width, (g.from+1)*40-20).stroke({ color: 'black', width: 2 })

                        this.svg.line(left, (g.to)*40+20, left, (g.to)*40+30).stroke({ color: 'black', width: 2 })
                        this.svg.line(left, (g.to)*40+30, left+width, (g.to)*40+30).stroke({ color: 'black', width: 2 })
                        this.svg.line(left+width, (g.to)*40+30, left+width, (g.to)*40+20).stroke({ color: 'black', width: 2 })
                    }
                })
            })
            this.svg.width(this.svg.bbox().w+1)
        },
        downloadSVG() {
            const base64doc = btoa(unescape(encodeURIComponent(document.querySelector('svg').outerHTML)))
            const a = document.createElement('a')
            const e = new MouseEvent('click')
            a.download = (this.name ? this.name : 'download')+'.svg'
            a.href = 'data:text/html;base64,' + base64doc
            a.dispatchEvent(e)
        },
        downloadJSON() {
            const base64doc = btoa(JSON.stringify({
                name: this.name,
                paperTypes: this.paperTypes,
                sheets: this.sheets
            }))
            const a = document.createElement('a')
            const e = new MouseEvent('click')
            a.download = (this.name ? this.name : 'download')+'.json'
            a.href = 'data:application/json;base64,' + base64doc
            a.dispatchEvent(e)
        },
        reset() {
            this.name = ''
            this.sheets = [
                {
                    id: 1,
                    name: '1r',
                    description: '',
                    connections: []
                }
            ]
            this.paperTypes = []
        },
        loadData() {
            const reader = new FileReader()
            reader.addEventListener('load', e => {
                let b64 = e.target.result.replace('data:application/json;base64,', '')
                let json = atob(b64)
                let data = JSON.parse(json)
                if(data.sheets && data.paperTypes) {
                    this.name = data.name ?? ''
                    this.sheets = data.sheets
                    this.paperTypes = data.paperTypes
                }
            })
            let input = document.createElement("input")
            input.setAttribute("type", "file")
            input.setAttribute("accept", "application/json")
            input.onchange = e => {
                console.log(e.target.files)
                let file = e.target.files[0]
                reader.readAsDataURL(file)
            }
            input.click()
        }
    },
    watch: {
        sheets: {
            deep: true,
            handler() {
                this.render()       
            }
        },
        paperTypes: {
            deep: true,
            handler() {
                this.render()       
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    button {
        display: inline-block;
        height: 28px;
        margin-bottom: 4px;
    }
    input {
        margin-right: 8px;
        margin-bottom: 4px;
        height: 22px;
    }
    select {
        margin-right: 8px;
        margin-bottom: 4px;
        height: 28px;
    }
    #download {
        width: 200px;
    }
    .name {
        margin-right: 0 !important;
        margin-bottom: 32px;
    }
    .editor {
        display: flex;
        flex-direction: column;
        .data {
            width: 1000px;
            display: flex;
            flex-direction: column;
            input {
                margin-right: 8px;
            }
            .paper-type {
                flex-grow: 1;
                display: flex;
                flex-direction: row;
                margin-bottom: 8px;
                width: 100%;
                input {
                    flex-grow: 1;
                }
            }
            .sheet {
                flex-grow: 1;
                display: flex;
                flex-direction: row;
                margin-bottom: 8px;
                width: 100%;
                .desc {
                    width: 300px;
                }
                .connections {
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;
                    .connection {
                        display: flex;
                        flex-direction: row;
                    }
                    select {
                        flex-grow: 1;
                    }
                }
            }
            .connections {
                margin-left: 32px;
            }
            .del {
                margin-left: 32px;
            }
        }
    }
    .button-row {
        display: flex;
        flex-direction: row;
        button {
            margin-right: 8px;
        }
    }
</style>
